import { render, staticRenderFns } from "./MemberDetailsPage.vue?vue&type=template&id=2e2a9e70&scoped=true&"
import script from "./MemberDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./MemberDetailsPage.vue?vue&type=script&lang=ts&"
import style0 from "./MemberDetailsPage.vue?vue&type=style&index=0&id=2e2a9e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2a9e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSelect,VTextField})
